<!--===================================
=            ECHARTSCOLLUM            =
====================================-->

<template>
   <div id="echart9"  style="width: 100%;height:250px;"></div>

</template>
<script>
export default {
  mounted(){

      var chartDom9 = document.getElementById('echart9');
      var myChart9 = echarts.init(chartDom9);
      var option9;

      option9 = {
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          data: [120, 200, 150, 80, 70, 110, 130],
          type: 'bar',

          symbolSize: 8,
          symbol: 'circle',
          smooth: true,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: '#004c4c'
              },
              {
                offset: 0.5,
                color: '#21b5bd'
              },
              {
                offset: 1,
                color: '#003333'
              }
            ]),

            width: 3,
            shadowColor: 'rgba(0,0,0,0.3)',
            shadowBlur: 10,
            shadowOffsetY: 8
          }
        }]
      };

      option9 && myChart9.setOption(option9); /* Chartjs (#areaChart1) */
  }
}
</script>

<!--====  End of ECHARTSCOLLUM  ====-->
